import { logger } from 'helpers/logger'
import { localStorage } from 'helpers/localStorage'
import { normalizeAtPathForRouter } from '@wellesley/router/pathNormalizer'

type StaticState = {
  path: string
  baseUrl: string
  search: string
}

const PARAM_NAME = 'staticState'
const storage = localStorage()

const defaultState = { path: '', baseUrl: '', search: '' }

const parseState = (state: string | null) => {
  if (!state) return defaultState

  try {
    return (
      (JSON.parse(decodeURIComponent(state)) as StaticState) || defaultState
    )
  } catch (error) {
    logger.error('Error parsing static state', error)
    return defaultState
  }
}
const getFromURL = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get(PARAM_NAME)
}
const create = ({
  path,
  baseUrl,
  search,
}: Partial<StaticState> | undefined = {}) => {
  const { pathname, origin, search: searchParams } = window.location
  const state = {
    path: path || normalizeAtPathForRouter(pathname),
    baseUrl: baseUrl || origin,
    search: search || searchParams,
  }
  return `${PARAM_NAME}=${encodeURIComponent(JSON.stringify(state))}`
}

const init = () => {
  const state = getFromURL()

  state && storage.setItem(PARAM_NAME, state)

  return get()
}

const get = (): StaticState => {
  try {
    const state = storage.getItem(PARAM_NAME) || getFromURL()
    return parseState(state)
  } catch (error) {
    logger.error('Error parsing static state', error)
    return defaultState
  }
}
export const staticState = {
  create,
  init,
  get,
}
